define(['jquery', 'c21', 'c21/rewrite', 'jquerybbq'], function ($, c21, rewrite) {
   "use strict";

   return function (bIgnoreHash) {
      var self = this,
         m_oParams = {},
         m_oHashParams = {},
         m_oFinalParams = {},
         m_oSeoParams,

         init = function () {
            var strHash = $.param.fragment(),
               sQuery = document.location.search.substring(1),
               bLid = (sQuery.indexOf("lid") >= 0) ? true : false,
               doSearch = function (key, value) {
                  m_oFinalParams[key] = value;
                  if (key === "lid") {
                     bLid = true;
                  }
               };

            m_oSeoParams = rewrite.match(document.location.pathname);

            m_oParams = c21.queryToJSON(sQuery);

            if (strHash && !bIgnoreHash) {
               m_oHashParams = c21.queryToJSON(strHash);
            }

            $.each(m_oSeoParams, doSearch);
            $.each(m_oParams, doSearch);
            $.each(m_oHashParams, doSearch);

            if (!bLid) {
               // Look for fallback lid
               var fallback = $("#fallbackLid");
               if (fallback.length) {
                  m_oFinalParams.lid = fallback.val();
               }
            }
         };

      this.set = this.setParam = function (sParam, sValue) {
         if (sValue === null) {
            if (m_oParams[sParam]) {
               m_oFinalParams[sParam] = c21.NULL;
            } else if (m_oHashParams[sParam]) {
               delete m_oFinalParams[sParam];
            }
         } else {
            m_oFinalParams[sParam] = sValue;
         }
      };

      this.remove = this.removeParam = function (sParam) {
         self.setParam(sParam, null);
      };

      this.get = this.getParam = function (sParam) {
         if (sParam) {
            return m_oFinalParams[sParam];
         } else {
            return m_oFinalParams;
         }
      };

      this.getParams = function () {
         return m_oFinalParams;
      };

      this.reload = function () {
         var sUrl = document.location.pathname,
            sQuery = $.param(m_oFinalParams);

         if (sQuery.length > 0) {
            sUrl += '?' + sQuery;
         }

         document.location = sUrl;
      };

      init();
   };
});
